import { useEffect } from 'react'

export function useOutsideClick(ref, closeFunc) {
  useEffect(() => {
    //Close an element if clicked outside the element
    function handleClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) {
        closeFunc(e)
      }
    }
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [ref])
}
